import { GetSearchParametersInterface } from './types';

export const getSearchParameters: GetSearchParametersInterface = (params) => {
  const paramsObject: Record<string, string> = {};
  //@ts-ignore
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }
  return paramsObject;
};
